import dayjs from 'dayjs'

import { MAX_RECURRENCE_YEARS } from '../consts'
import type { Repeat } from '../types'

export type RecurrencePeriodUnit = 'week' | 'month' | 'year'

/**
 * UNTIL в RRULE включительный: период в N units заканчивается накануне start+N,
 * иначе в календаре появляется лишний день (неделя→8 дней и т.п.).
 */
export const inclusivePeriodEnd = (
  from: dayjs.Dayjs,
  amount: number,
  unit: RecurrencePeriodUnit,
): dayjs.Dayjs => from.add(amount, unit).subtract(1, 'day')

/** UNTIL до фикса WUI-5605: start + period без −1 day. */
export const legacyPeriodEnd = (
  from: dayjs.Dayjs,
  amount: number,
  unit: RecurrencePeriodUnit,
): dayjs.Dayjs => from.add(amount, unit)

export const periodEndForRepeat = (from: dayjs.Dayjs, repeat: Repeat): dayjs.Dayjs => {
  if (repeat === 'week') {
    return inclusivePeriodEnd(from, 1, 'week')
  }
  if (repeat === 'month') {
    return inclusivePeriodEnd(from, 1, 'month')
  }
  return inclusivePeriodEnd(from, MAX_RECURRENCE_YEARS, 'year')
}

const isSameCalendarDay = (left: dayjs.Dayjs, right: dayjs.Dayjs) => left.isSame(right, 'day')

/** Совпадение с inclusive UNTIL или legacy (для разбора уже созданных событий). */
export const matchesRepeatPeriodEnd = (
  untilDay: dayjs.Dayjs,
  startDay: dayjs.Dayjs,
  amount: number,
  unit: RecurrencePeriodUnit,
): boolean => (
  isSameCalendarDay(untilDay, inclusivePeriodEnd(startDay, amount, unit))
  || isSameCalendarDay(untilDay, legacyPeriodEnd(startDay, amount, unit))
)
